module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_2-c65bb1d48cb9266398522a7591db4dad.jpg";